/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

export default {
	updateConfirmGoodsVatRates(state, res) {
		state.ConfirmVatRates = res.Data;
	},

	updateTotalPage(state, res) {
		state.Total = res;
	},

	updateLoadingTotalRecords(state, res) {
		state.IsLoading = res;
	},

	updateDeleteConfirmGoodsVatRate(state, res) {
		if (state.Total >= 0) {
			state.Total -= 1;
		} else {
			state.Total = 0;
		}
	},

	updateConfirmGoodsVatRate(state, res) {
		state.ConfirmVatRate = res;
	},

	updateConfirmGoodsVatRateById(state, res) {
		if (!res) return;
		let index = state.ConfirmVatRates.findIndex(x => x.ConfirmGoodsVatRateId == res.ConfirmGoodsVatRateId);
		if (index >= 0) {
			state.ConfirmVatRates[index] = res;
		}
	}
};
